const breakpoints = {
  xs: "320",
  // minimum width
  sm: "600",
  // tablet
  md: "960",
  // desktop
  lg: "1280" // oversized

};
export { breakpoints };